<template>
  <el-container>
    <el-aside width="613px">
      <el-container>
        <el-header>
          <el-form :inline="true">
            <el-form-item label="货号：">
              <el-input v-model.trim="tableConfig.searchForm.data.ItemNo"></el-input>
            </el-form-item>
            <el-form-item label="供应商：">
              <el-input v-model="tableConfig.searchForm.data.SupplierName"></el-input>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" @click="handleQuery()">查询</el-button>
              <el-button type="default" @click="reset">重置</el-button>
              <el-dropdown @command="handleExport">
                <el-button type="primary" plain>
                  导出
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="ProductID">导出到货号</el-dropdown-item>
                  <el-dropdown-item command="SpecID">导出到规格</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main>
          <grid-table
            ref="gridTable"
            :showIndexColumn="false"
            :showCheckboxColumn="false"
            :showLastEmptyColumn="false"
            :showPagination="true"
            :tableConfig="tableConfig"
            @handleRowClick="handleRowClick"
            :resizable="false"
          ></grid-table>
        </el-main>
      </el-container>
    </el-aside>
    <el-main>
      <stock-detail :product-id="curProductID" @refresh="handleQuery(true)"></stock-detail>
    </el-main>
  </el-container>
</template>

<script>
import { exportFile } from '@/api/base'
import dayjs from 'dayjs'
import StockDetail from './components/StockDetail.vue'

export default {
  name: 'stockIndex',
  components: {
    StockDetail,
  },
  data() {
    return {
      tableConfig: {
        url: '/api/wms/stock/getPageList',
        rowKey: 'ProductID',
        searchForm: {
          data: {
            ItemNo: '',
            SupplierName: '',
          },
        },
        columns: [
          {
            label: '货号',
            prop: 'ItemNo',
            type: 'text',
            width: '178px',
          },
          {
            label: '当前库存',
            prop: 'Stock',
            type: 'text',
          },
          {
            label: '占用库存',
            prop: 'OccupyStock',
            type: 'text',
          },
          {
            label: '剩余库存',
            prop: 'LeftStock',
            type: 'text',
          },
          {
            label: '货架',
            prop: 'Shelves',
            type: 'text',
          },
        ],
      },
      curProductID: null,
      exportLoading: false,
    }
  },
  mounted() {
    this.handleQuery()
  },
  methods: {
    async handleQuery(refresh = false) {
      this.$refs.gridTable.fetchData(
        true,
        datas => {
          if (refresh) {
            for (const row of datas) {
              if (row.ProductID == this.curProductID) {
                this.$refs.gridTable.$refs.gridTable.toggleRowSelection(row)
                break
              }
            }
          } else {
            this.curProductID = null
          }
        },
        null,
        true
      )
    },
    reset() {
      this.tableConfig.searchForm.data.SupplierName = ''
      this.tableConfig.searchForm.data.ItemNo = ''
      this.handleQuery()
    },
    async handleRowClick(row) {
      this.$refs.gridTable.$refs.gridTable.clearSelection()
      this.$refs.gridTable.$refs.gridTable.toggleRowSelection(row)
      this.curProductID = row.ProductID
    },
    async handleExport(command) {
      this.exportLoading = true
      const { data } = await exportFile('/api/wms/stock/export', {
        ...this.tableConfig.searchForm.data,
        ExportType: command,
      })
      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      const today = dayjs().startOf('day').format('YYYYMMDD')
      a.download = '商品库存_' + today + '.xls'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      this.exportLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-header {
    height: auto !important;
  }

  .el-aside {
    .el-form {
      .el-select {
        width: 100px;
        margin-right: 5px;
      }

      .el-form-item__label {
        padding-right: 0;
      }

      .el-input__inner {
        width: 120px;
      }

      .el-dropdown {
        margin-left: 10px;
      }

      .el-form-item:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
